<template>
    <v-app>
        <Tab1 @changeTab="tab = $event" :tabList="tabList" v-if="tab === 0"></Tab1>
        <Tab2 @changeTab="tab = $event" :tabList="tabList" v-if="tab === 1"></Tab2>
        <Tab3 @changeTab="tab = $event" :tabList="tabList" v-if="tab === 2"></Tab3>
    </v-app>
</template>
<script>
    import Tab1 from '@/views/Resume/Tab1';
    import Tab2 from '@/views/Resume/Tab2';
    import Tab3 from '@/views/Resume/Tab3';
    export default {
        name: "IndexResume",
        components: {
            Tab1,
            Tab2,
            Tab3
        },
        data: () => ({
            tab: null,
            tabList: [
                "Modèle lettre de motivation",
                "Conseils pour une bonne candidature",
                "Pour bien préparer vos candidatures"
            ],
        }),
        created() {
            this.tab = this.$route.query.tab ?? 0;
        }
    }

</script>
